const LeasingListData = [
    {
        code: "ADMF",
        name: "PT ADIRA FINANCE"
    },
    {
        code: "BPAS",
        name: "BPR AlSalaam"
    },
    {
        code: "BPRM",
        name: "PT BPR EMAS NUSANTARA"
    },
    {
        code: "BAFF",
        name: "PT BUSSAN AUTO FINANACE"
    },
    {
        code: "FIFG",
        name: "PT FEDERAL INTERNATIONAL FINANCE"
    },
    {
        code: "BMOR",
        name: "PT BALIMOR ORICO FINANCE"
    },
    {
        code: "GC",
        name: "GC AMARTA BANDUNG"
    },
    {
        code: "MANF",
        name: "PT MANDALA FINANCE"
    },
    {
        code: "MCFI",
        name: "PT MEGA CENTRAL FINANCE"
    },
    {
        code: "MGAF",
        name: "PT MEGA FINANCE"
    },
    {
        code: "MUFI",
        name: "PT MANDIRI UTAMA FINANCE"
    },
    {
        code: "OTOF",
        name: "PT OTO FINANCE"
    },
    {
        code: "TRAN",
        name: "PT TRANSPACIFIC"
    },
    {
        code: "WOMF",
        name: "PT WOM FINANCE"
    },
    {
        code: "BCAF",
        name: "PT BCA FINANCE"
    },
    {
        code: "MYBF",
        name: "PT MAYBANK FINANCE"
    },
    {
        code: "CNAF",
        name: "PT CIMB NIAGA AUTO FINANCE"
    },
    {
        code: "BUAF",
        name: "PT BUSSAN AUTO FINANACE"
    },
];

export default LeasingListData;
